import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiSelectComponent } from './multi-select.component';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectOptionAtomModule } from '../select-option/select-option.module';


@NgModule({
  declarations: [MultiSelectComponent],
  imports: [
    CommonModule,
    MatSelectModule,
    SelectOptionAtomModule,
    ReactiveFormsModule
  ],
  exports: [MultiSelectComponent]
})
export class MultiSelectModule { }
